<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="mt-3">
      <!-- Hearing Test Words -->
      <div class="content">
        <div class="d-flex justify-content-center">
          <span class="header header-2">
              <!-- {{$t('first_stage.adjust_message')}} -->
              <span v-if="!testHasStarted">{{$t('numbers_test.adjust_volume')}}</span>
              <span v-else>{{$t('words_test.choose')}}</span>
          </span>
        </div>

        <div v-if="!testHasStarted" class="d-flex justify-content-center mt-md-5">
          <img src="public/sound.svg" alt="" class="sound-icon">
        </div>

        <div v-if="!testHasStarted" class="d-flex justify-content-center mt-5">
          <button type="button" class="button primary" @click="startTest()">{{$t('actions.start')}}</button>
        </div>

        <div v-else>
          <div class="d-flex justify-content-around w-100">
            <div class="d-flex justify-content-end sound-wrapper" v-if="!isMobileDevice">
              <img v-if="showAnimations && showLeftAnimation" class="sound-waves" :src="leftImage">
            </div>
            <transition-group name="list" tag="div" class="row justify-content-md-center words-wrapper" :class="{'clickable': !disableButtons}">
              <div class="flip-card col-4 col-md-4 grid-word" v-for="word in words" :key="word.id" @click="evaluateCalibrationAnswer(word)" :class="word.class">
                <div class="flip-card-inner">
                  <div class="flip-card-front">
                    <img :src="getFullImagePath(word)" alt="" class="normal-image">
                    <img :src="getFullImagePathHover(word)" alt="" class="hover-image">
                    <img :src="getFullImagePathSelected(word)" alt="" class="selected-image">
                  </div>
                  <div class="flip-card-back">
                    <i class="far fa-check-circle"></i>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="d-flex justify-content-start" v-if="!isMobileDevice">
              <img v-if="showAnimations && showRightAnimation" class="sound-waves" :src="rightImage">
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <span class="header header-4">
                <!-- Respostas: {{ answerOrder }} de 3 -->
                {{$t('numbers_test.completed')}} <b>{{ percentageCompleted }} %</b>
            </span>
          </div>
        </div>
          
          <!-- <fade-transition :duration="250" v-if="answerWrong" class="d-flex justify-content-center mt-3">
            <span class="header header-4 header-danger">
              {{$t('first_stage.wrong_answer_message')}}
            </span>
          </fade-transition> -->
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import Words from '../utils/Sounds'
import FadeTransition from './Utils/FadeTransition.vue'
export default {
  props: {
    handler: {
      type: Object,
      required: true
    }
  },
  components: {
    FadeTransition
  },
  data () {
    return {
      calibrationAnswer: {
        word: null,
        result: null
      },
      instructionsEnded: false,
      disableButtons: false,
      testHasStarted: false,
      levelStarted: false,
      words: this.$i18n.locale === 'pt' ? Words.words.pt.map((item, index) => {
        return {
          id: index + 1,
          name: item.name,
          image: item.image,
          class: 'no-action'
        }
      }).slice(0, 9) : Words.words.en.map((item, index) => {
        return {
          id: index + 1,
          name: item.name,
          image: item.image,
          class: 'no-action'
        }
      }).slice(0, 9),
      answerOrder: 0,
      channel: null,
      interval: null,
      activeImageIndex: 1,
      showAnimations: false,
      showRightAnimation: true,
      showLeftAnimation: true,
      percentageCompleted: 0
      // answerWrong: false
    }
  },
  mounted () {
    this.handler.hearingTestWords.eventEmitter.on('instructionsEnded', () => {
      // console.log('instructionsEnded')
      this.instructionsEnded = true
      this.initAnimation()
    })
    this.handler.hearingTestWords.eventEmitter.on('channelUpdated', (channel) => {
      // console.log(channel)
      this.channel = channel
    })
    this.handler.hearingTestWords.eventEmitter.on('wordsTestEnded', (results) => {
      // console.log(results)
      this.$emit('update:ht_words', results)
      this.$emit('continue')
    })
    this.handler.hearingTestWords.eventEmitter.on('answer-result', (payload) => {
      this.calibrationAnswer = payload
    })
    this.handler.hearingTestWords.eventEmitter.on('levelStarted', () => {
      // console.log('levelStarted')
      this.levelStarted = true
      this.answerOrder = 0
      this.showAnimations = true
      this.activeImageIndex = 1
    })
    this.handler.hearingTestWords.eventEmitter.on('soundEnded', () => {
      this.showAnimations = false
    })
    this.handler.hearingTestWords.eventEmitter.on('levelEnded', (percentageCompleted) => {
      // console.log('levelEnded')
      this.percentageCompleted = parseInt(percentageCompleted * 100)
      this.levelStarted = false
      setTimeout(() => {
        this.words.forEach(word => {
          word.class = ''
        })
      }, 850)
    })
    this.handler.playWordsInstructions()
  },
  methods: {
    // updateAnswerResult: function (payload) {
    //   this.calibrationAnswer = payload
    // },
    startTest: function () {
      this.handler.initWords()
      this.testHasStarted = true
    },
    evaluateCalibrationAnswer: function (word) {
      if (!this.instructionsEnded) return
      if (!this.levelStarted) return
      if (word.class == 'answer-selected') return
      if (!this.disableButtons) {
        this.handler.evaluateWord(word.name)
        this.answerOrder++
        this.disableButtons = true
        setTimeout(() => {
          this.disableButtons = false 
        }, 1000)
      }
    },
    getFullImagePath: function (word) {
      return `public/${word.image}`
    },
    getFullImagePathHover: function (word) {
      return `public/${word.name}_hover.svg`
    },
    getFullImagePathSelected: function (word) {
      return `public/${word.name}_selected.svg`
    },
    initAnimation: function () {
      this.interval = setInterval(() => {
        if (this.activeImageIndex + 1 <= 3) {
          this.activeImageIndex ++
        } else {
          this.activeImageIndex = 1
        }
      }, 1000)
    },
  },
  computed: {
    rightImage: function () {
      return `public/right_${this.activeImageIndex}.svg`
    },
    leftImage: function () {
      return `public/left_${this.activeImageIndex}.svg`
    },
    isMobileDevice: function () {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
  },
  watch: {
    calibrationAnswer: {
      handler: function (answer) {
        if (answer.word) {
          let word = this.words.find(item => item.name === answer.word)
          word.class = 'answer-selected'
        }
      },
      deep: true
    },
    instructionsEnded: function (value) {
      this.words = this.words.map(item => {
        return {
          ...item,
          class: ''
        }
      })
    },
    channel: function (channel) {
      if (channel === 'single') {
        this.showLeftAnimation = true
        this.showRightAnimation = true
      } else if (channel === 'left') {
        this.showLeftAnimation = true
        this.showRightAnimation = false
      } else if (channel === 'right') {
        this.showLeftAnimation = false
        this.showRightAnimation = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-evollu {
  color: #29c4a9;
}

.text-black {
  color: #181818;
}

.instruction-message {
  color: #414244;
}

.grid-container {
  display: grid;
  grid-template-columns: auto auto auto;
  background-color: #2196F3;
  padding: 10px;
}

.words-wrapper.clickable{
  cursor: pointer;
}

.grid-word {
  /* width: 110px; */
  width: 50px;
  height: 150px;
  background-size: cover;
  background-position: center;
  padding: 10px !important;
  .flip-card-inner {
    box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.2);
  }
}

// @media only screen and (max-width: 768px) {
//   .grid-word {
//     width: 30px;
//     height: 125px;
//   }

//   .words-wrapper {
//     margin-top: 3rem;
//   }
// }

@media only screen and (min-width: 1350px) {
  .words-wrapper {
    margin: 0 10rem;
  }
}

.hover-image,
.selected-image {
  display: none;
}

@media only screen and (min-width: 769px) {
  .grid-word:hover:not(.no-action):not(.answer-selected) {
    .normal-image {
      display: none;
    }
    .hover-image {
      display: block;
    }
    cursor: pointer;
  }
}

.grid-word.answer-correct {
  border: 2px solid #29c4a9 !important;
}

.grid-word.answer-wrong {
  border: 2px solid #e34a4a !important;
  animation: shake 0.5s;
}

.grid-word.answer-selected {
  .normal-image, .hover-image {
    display: none;
  }
  .selected-image {
    display: block;
  }
  .flip-card-inner {
    background-color: #29c4a9;
  }
  cursor: default;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.grid-word > img {
  width: 100%;
  height: 100%;
  perspective: 1000px;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.start-calibration-btn {
  background-color: #29c4a9;
  color: #fff;
}

.flip-card img {
  height: 120px;
  width: 120px;
  max-width: -webkit-fill-available;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card.answer-correct .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.flip-card-back {
  transform: rotateY(180deg);
  font-size: 4.5rem;
  color: #29c4a9;
}

.sound-icon {
  height: 250px;
  max-height: 30vh;
}

</style>